module.exports = __webpack_public_path__ + "static/media/illustration-intro.6a53bba8.svg";